import { CompanyHub } from "@/features/companies/CompanyHub";
import {
  useAppShell,
  useRefreshProfileAfterCompanyCreated
} from "@/shell/app-shell-context";

/** `/empresas` — catálogo completo. */
export function CompaniesRoute() {
  const { profile, token, refreshProfile } = useAppShell();
  const companyCreated = useRefreshProfileAfterCompanyCreated();

  return (
    <CompanyHub
      profile={profile}
      token={token}
      onCompanyCreated={companyCreated}
      onCompanyStateChanged={refreshProfile}
      adminHref="/admin"
    />
  );
}
